function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var SeekDataManager = /*#__PURE__*/ function() {
    "use strict";
    function SeekDataManager() {
        _class_call_check(this, SeekDataManager);
        _define_property(this, "_from", void 0);
        _define_property(this, "_to", void 0);
        _define_property(this, "_wasManaged", false);
    }
    _create_class(SeekDataManager, [
        {
            key: "clear",
            value: function clear() {
                this._from = undefined;
                this._to = undefined;
                this._wasManaged = false;
            }
        },
        {
            key: "update",
            value: function update(param, isNonPeiSeek) {
                var from = param.from, to = param.to, toManaged = param.toManaged;
                // Non PEI seeks are used by Shaka for gap jumping.
                // To be safe we should allow these events without trying to manage them
                // despite the fact that this allows the skipping of ads
                if (this._wasManaged && !isNonPeiSeek) {
                    return;
                }
                var _this__from;
                // One "seek" encapsulates a single "from" position until seek ends
                this._from = (_this__from = this._from) !== null && _this__from !== void 0 ? _this__from : from;
                this._to = to;
                if (toManaged !== undefined && !this.checkSeekPositionEquality(to, toManaged)) {
                    this._to = toManaged;
                    this._wasManaged = true;
                }
            }
        },
        {
            key: "from",
            get: function get() {
                return this._from;
            }
        },
        {
            key: "to",
            get: function get() {
                var _this__to;
                return (_this__to = this._to) !== null && _this__to !== void 0 ? _this__to : this._from;
            }
        },
        {
            key: "wasManaged",
            get: function get() {
                return this._wasManaged;
            }
        },
        {
            key: "checkSeekPositionEquality",
            value: function checkSeekPositionEquality(a, b) {
                return Math.ceil(a) === Math.ceil(b);
            }
        }
    ]);
    return SeekDataManager;
}();

//# sourceMappingURL=seek-data-manager.js.map